import getRouteDateTime from "@Route/functions/getRouteDateTime"
import RouteType from "@Route/types/Route.type"

export default function isSameRouteBasedOnTravelTimes(route: RouteType, comparedRoute: RouteType) {
    return getRouteDateTime({route, type: "departure"}) === getRouteDateTime({route: comparedRoute, type: "departure"})
    && getRouteDateTime({route, type: "arrival"}) === getRouteDateTime({route: comparedRoute, type: "arrival"})
}